import { useMemo } from "react";
import classNames from "classnames";
import { calcProgressbarPixels } from "./utils";
import "./styles.sass";

type LoyaltyRankProgressProps = {
  userExperience: number;
  rankExperience: number;
  prevRankExperience: number;
  className?: string;
  isFinal?: boolean;
};

export const LoyaltyRankProgress = (props: LoyaltyRankProgressProps) => {
  const {
    userExperience,
    rankExperience,
    prevRankExperience,
    className,
    isFinal = false,
  } = props;
  const widthProgress = useMemo(
    () =>
      calcProgressbarPixels({
        userExperience,
        rankExperience,
        prevRankExperience,
        isFinal,
      }),
    [userExperience, rankExperience, prevRankExperience, isFinal],
  );

  return (
    <div className={classNames("LoyaltyRankProgress", className)}>
      <div
        style={{ width: widthProgress }}
        className="LoyaltyRankProgress__progress"
      />
    </div>
  );
};
